module.exports = __webpack_public_path__ + "img/logo.adbb69d0.png";